import React, { useEffect, useRef } from "react";

interface Props {
  onPlaceSelect: (name: string, lat: string, lng: string) => void;
}

const PlacesAutocompleteInput: React.FC<Props> = ({ onPlaceSelect }) => {
  const containerRef = useRef<HTMLDivElement>(null);
  const callbackRef = useRef(onPlaceSelect);

  useEffect(() => {
    callbackRef.current = onPlaceSelect;
  }, [onPlaceSelect]);

  useEffect(() => {
    if (!containerRef.current) return;

    const autocomplete = new (window as any).google.maps.places.PlaceAutocompleteElement({
      types: ["geocode"],
    });

    containerRef.current.appendChild(autocomplete);

    const handleSelect = (event: any) => {
      const placePrediction = event.placePrediction;
      if (!placePrediction) return;

      const placeId: string = placePrediction.placeId;
      const fallbackName: string = placePrediction.mainText?.text ?? placePrediction.text?.text ?? "";

      // Use classic PlacesService (Places API) to get geometry — avoids requiring "Places API (New)"
      const service = new (window as any).google.maps.places.PlacesService(
        document.createElement("div")
      );

      service.getDetails(
        { placeId, fields: ["name", "geometry"] },
        (place: any, status: any) => {
          const OK = (window as any).google.maps.places.PlacesServiceStatus.OK;
          if (status === OK && place?.geometry?.location) {
            callbackRef.current(
              place.name ?? fallbackName,
              String(place.geometry.location.lat()),
              String(place.geometry.location.lng())
            );
          }
        }
      );
    };

    autocomplete.addEventListener("gmp-select", handleSelect);

    return () => {
      autocomplete.removeEventListener("gmp-select", handleSelect);
    };
  }, []);

  return <div ref={containerRef} className="w-full mb-3" />;
};

export default PlacesAutocompleteInput;
